import React, { Fragment, useState, useContext } from 'react';
import EmailQuote from './EmailQuote';
import Button from '../UI/Button';
import { Link } from 'react-router-dom';
import styles from "./QuoteHeader.module.css";
import AppContext from '../../store/app-context';
import AuthContext from '../../store/auth-context';

const QuoteHeader = (props) => {
    const appCtx = useContext(AppContext);
    const authCtx = useContext(AuthContext);
    {/*
    const [isEmailModalDisplayed, setIsEmailModalDisplayed] = useState(false);

    const showEmailModalHandler = () =>{
        setIsEmailModalDisplayed(true);
    }

    const hideEmailModalHandler = () =>{
        setIsEmailModalDisplayed(false);
    }


    let totalItem = 0;
    if(props && props.quote && props.quote.quoteLineEntityList && props.quote.quoteLineEntityList.length > 0){
        props.quote.quoteLineEntityList.forEach((item) => (
            totalItem = totalItem + parseInt(item.quantity)
        ));
    }

    */}

    let label_requestQuote = 'Request a Quote';
    let label_quoteItems = 'Items:';
    let label_quoteHistory = 'View Saved Quotes';
    let label_shoppingCart = 'Shopping Cart';

    if(appCtx && appCtx.bioradResources){
        label_requestQuote = appCtx.bioradResources.Quote_Cart ? appCtx.bioradResources.Quote_Cart : 'Request a Quote';
        label_quoteItems = appCtx.bioradResources.Quote_Items ? appCtx.bioradResources.Quote_Items : 'Items: ';
        label_quoteHistory = appCtx.bioradResources.Quote_History ? appCtx.bioradResources.Quote_History : 'View Saved Quotes';
        label_shoppingCart = appCtx.bioradResources.Shopping_Cart ? appCtx.bioradResources.Shopping_Cart : 'Shopping Cart';
    }

    const cartURL = appCtx.envProp.appServer +
    "bc/" +
    appCtx.lang.toLowerCase() +
    "-" +
    appCtx.country.toLowerCase() +
    "/cart";

    return (
        <div className={styles.fullWidth}>
            <div className={styles.header_view}>
                <h1>{label_requestQuote}</h1>
                <span><a href={cartURL} className={styles.btnlinkU} >{label_shoppingCart}</a></span>
            </div>
            {authCtx.isLoggedIn && (
                <div className={styles.quote_links}>
                    {/*
                        <Button onClick={showEmailModalHandler}>Email Quote</Button>
                        {isEmailModalDisplayed && <EmailQuote onClose={hideEmailModalHandler}/>}
                        <span> | </span>
                    */}
                    <Link to="/quotes">{label_quoteHistory}</Link>
                </div>
            )}
        </div>
    );
};

export default QuoteHeader;